export default {
  token: 'token',
  tenantCode: 'tenantCode',
  permissions: 'PERMISSIONS',
};
